import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';

import { UserService } from '../../../services/user.service';
import { ToastComponent } from '../../toast/toast.component';
import { User } from '../../models/user.model';
import { ee, jobs } from '../../constants';
import { setClassInvalidTpl } from '../../functions';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-edit-user-modal',
  templateUrl: './edit-user-modal.component.html',
  standalone: false
})
export class EditUserModalComponent implements OnInit, OnDestroy {
  toast = inject(ToastComponent);
  private userService = inject(UserService);


  @Input() user: User;
  @Input() field = '';

  jobs = jobs;
  setClassInvalidTpl = setClassInvalidTpl;

  ngOnInit(): void {
    // This is executed N+1 times, to fix eventually
    ee.on('showEditUserModal', (field: string) => this.field = field);
  }

  ngOnDestroy(): void {
    ee.off('showEditUserModal', () => {});
  }

  updateUser(field: string): void {
    const user: User = {
      _id: this.user._id,
      [field]: this.user[field]
    };
    this.userService.updateJob(user)
      .pipe(finalize(() => ee.emit('getUsers')))
      .subscribe({
        next: res => this.toast.setMessage('User updated successfully', 'success'),
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

}
